import { LayingPatternViewer } from 'CommonScripts/layingPatternViewer';
import { ProductSynopses, ProductTexture } from 'CommonData/poco';
import { productSynopses, baseProductTextures } from './textureSelect';

export class Share {
    public static setEventListeners() {
        const shareItemEls: HTMLCollectionOf<Element> = document.getElementsByClassName('js-share-item');

        [].slice.call(shareItemEls).forEach((el: Element) => {
            el.addEventListener('click', () => {
                const shareType: string = el.getAttribute('data-share-type');

                if (!shareType) {
                    console.error('Share type not found in Share.setEventListeners for element:', el);
                    return;
                }

                const matchingProductSynopses: ProductSynopses = productSynopses.find((ps: ProductSynopses) => ps.id === baseProductTextures.find((pt: ProductTexture) => LayingPatternViewer.getCurrentTexture().ProductTextureKey === pt.textureKey).productId);
                const shareLink: string = encodeURIComponent(LayingPatternViewer.getShareLink());
                const shareText: string = `Visualise Marshalls ${matchingProductSynopses.name}`;

                switch (shareType) {
                    case ShareTypes.Facebook:
                        window.open(`https://www.facebook.com/sharer.php?u=${shareLink}`);
                        break;
                    
                    case ShareTypes.Twitter:
                        window.open(`https://twitter.com/share?url=${shareLink}&text=${shareText}`);
                        break;
                    
                    case ShareTypes.LinkedIn:
                        window.open(`https://www.linkedin.com/shareArticle?url=${shareLink}&title=${shareText}`);
                        break;

                    case ShareTypes.Pinterest:
                        window.open(`https://pinterest.com/pin/create/bookmarklet/?url=${shareLink}&is_video=false&description=${shareText}`);
                        break;

                    case ShareTypes.WhatsApp:
                        window.open(`https://api.whatsapp.com/send?text=${shareText}: ${shareLink}`);
                        break;

                    case ShareTypes.Email:
                        document.location = `mailto:?subject=${shareText}&body=${shareLink}`;
                        break;
                }
            });
        })
    }
}

enum ShareTypes {
    Facebook = 'facebook',
    Twitter = 'twitter',
    LinkedIn = 'linkedin',
    Pinterest = 'pinterest',
    WhatsApp = 'whatsapp',
    Email = 'email'
}

Share.setEventListeners();